import { render } from "./ProgramVerticalCard.vue?vue&type=template&id=6067f613"
import script from "./ProgramVerticalCard.vue?vue&type=script&lang=js"
export * from "./ProgramVerticalCard.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/su-zaytoon-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__